"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blog = void 0;
var base = 'https://feather-insurance.com/blog';
exports.blog = {
    base: base + "/",
    healthInsuranceGuide: base + "/our-complete-guide-to-health-insurance-in-germany/",
    addDependentsToHealthInsurance: base + "/how-to-add-dependents-to-your-health-insurance/",
    ehicGuide: base + "/how-long-is-the-european-health-insurance-card-valid-after-moving-to-germany/",
    schufaGuide: base + "/how-can-you-improve-your-schufa-score/",
    useExpatHealthInsuranceForVisa: base + "/how-can-i-use-expat-health-insurance-for-my-visa/",
    insuranceAfter55: base + "/how-to-get-insurance-after-55/",
};
